import { render, staticRenderFns } from "./initiateApproval.vue?vue&type=template&id=817f28ac&scoped=true&"
import script from "./initiateApproval.vue?vue&type=script&lang=js&"
export * from "./initiateApproval.vue?vue&type=script&lang=js&"
import style0 from "./initiateApproval.vue?vue&type=style&index=0&id=817f28ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817f28ac",
  null
  
)

export default component.exports